import { render, staticRenderFns } from "./AwaitingInstallmentDeductionReport.vue?vue&type=template&id=51551a6e"
import script from "./AwaitingInstallmentDeductionReport.vue?vue&type=script&lang=js"
export * from "./AwaitingInstallmentDeductionReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports